
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Reference No', value: 'reference_number'},
  { text: 'MID', value: 'mid'},
  { text: 'Nama Merchant', value: 'merchant_name'},
  { text: 'MPAN', value: 'mpan'},
  { text: 'Email', value: 'receiver', width: '300'},
  { text: 'Tipe Email', value: 'type', width: '250'},
  { text: 'Last Send Date', value: 'last_resend_at'},
  { text: 'Number of Resend', value: 'resend_count', align: 'center', textAlign: 'text-center'},
  { text: 'Status', value: 'status',  align: 'center', textAlign: 'text-center'},
  { text: 'Action', value: 'action', width: '10' }
]);

export const dataListEmailType = [
  { value: 'Activation Merchant', text: 'Activation Merchant' },
];

export const dataResendEmailStatus = [
  { value: '0', text: 'Waiting' },
  { value: '1', text: 'On process' },
  { value: '2', text: 'Success' },
  { value: '3', text: 'Failed' },
];

export const search = {
  reference_number: '',
  mid: '',
  merchant_name: '',
  mpan: '',
  receiver: '',
  type: '',
  last_resend_at: '',
  resend_count: null,
  status: '',
};

